export default __webpack_public_path__ + "static/part-time-advantage-1-c79a526ad62b8b29d390ab58a83775db.png";